import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { getTextHoverChat } from 'flow/utils/meeting-utils';
import { selectActiveMeetingChatOpen } from 'flow/selectors/meeting-selectors';
import { getFooterButtonHiddenClass } from 'flow/utils/meeting-footer-utils';
import useMeetingChatState from 'flow/hooks/useMeetingChatState';
import useMeetingChatOpen from 'flow/hooks/useMeetingChatOpen';
import MeetingButton from 'flow/components/meeting/MeetingButton';
import Notification from 'flow/components/ui-components/Notification';

export const ButtonChatBadge = () => {
    const { i18next } = useAppContext();

    const chatIsOpen = useAppSelector(selectActiveMeetingChatOpen);
    const { openChat, opensInMeetingChat } = useMeetingChatOpen();
    const { chatDisabled, numberOfUnreadMessages } = useMeetingChatState();

    return (
        <div
            className={twMerge(
                'relative flex flex-col items-center justify-center text-xs select-none',
                getFooterButtonHiddenClass(),
            )}
        >
            <MeetingButton
                iconType={'chat_outlined'}
                active={chatIsOpen}
                subtleActive={true}
                invertOnHover={true}
                callback={chatDisabled ? () => {} : openChat}
                hoverText={getTextHoverChat(
                    !chatDisabled,
                    opensInMeetingChat,
                    chatIsOpen,
                    i18next,
                )}
                disabled={chatDisabled}
                circular={true}
            />
            {numberOfUnreadMessages > 0 && (
                <Notification className="end-0 top-0">
                    {numberOfUnreadMessages}
                </Notification>
            )}
        </div>
    );
};

export default ButtonChatBadge;
